import { pxToRem, type StyleRule } from '@archipro-design/aria';

export const FilterBarFiltersWrapper: StyleRule = () => ({
    '> *:not(:last-child)': {
        marginRight: pxToRem(45),
    },
});
